import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DriversPowerSelect from '../drivers/drivers-power-select.jsx';
import 'react-power-select/dist/react-power-select.css';
import CurrencyInput from 'react-currency-input';
import moment from 'moment';

export default class PortalJobScheduler extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      isLoading: props.isLoading || true,
      job: props.data || null,
      jobId: props.jobId || null,
      job_admin_fee_in_pence: null,
      job_admin_fee_in_pence_formatted: null,
      customers: null,
      customer_id:props.data.customer_id || '',
      scheduledDates: this.getScheduledDates(props.data),
    };
    this.handlePickupDateCalendarChange = this.
    handlePickupDateCalendarChange.bind(this);
    this.handleDropoffDateCalendarChange = this.
    handleDropoffDateCalendarChange.bind(this);
    this.handleScheduledPickupDateCalendarChange = this.
    handleScheduledPickupDateCalendarChange.bind(this);
    this.handleScheduledDropoffDateCalendarChange = this.
    handleScheduledDropoffDateCalendarChange.bind(this);

    this.handleDriverSelection = this.
    handleDriverSelection.bind(this);
  }
  componentDidMount() {
    this.getCustomersForDropdownMenu();
  }
  handleDriverSelection(selectedOption) {
    this.setState({driver_id: selectedOption.driver_id});
  }
  getCustomersForDropdownMenu() {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/customers/all/for-dropdown-menu",
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(customersJson) {
      that.setState({
        customers: customersJson
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    const previousDates = this.getScheduledDates(this.props.data);
    const nextDates = this.getScheduledDates(nextProps.data);
    if (nextProps.jobId !== this.props.jobId ||
        JSON.stringify(previousDates) !== JSON.stringify(nextDates)) {
      this.setState({scheduledDates: nextDates});
    }
    this.setState({
      jobId: nextProps.jobId,
      job: nextProps.data,
      isLoading: nextProps.isLoading,
    });
  }

  handleDropoffDateCalendarChange(date) {
    

    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=dropoff_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=dropoff_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);

    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=dropoff_year]'
    ).value = date.getFullYear();

    this.setState({
      dropoff_date: date
    });
  }
  handlePickupDateCalendarChange(date) {
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=pickup_day]'
    ).value = ("0" + (date.getDate())).slice(-2);

    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=pickup_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);

    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=pickup_year]'
    ).value = date.getFullYear();

    this.setState({
      pickup_date: date
    });
  }
  getScheduledDates(job = {}) {
    const dates = {};
    ['dropoff', 'pickup'].forEach(type => {
      dates[type] = {};
      ['day', 'month', 'year'].forEach(part => {
        dates[type][part] = String((job && job['scheduled_' + type + '_' + part]) || '?');
      });
    });
    return dates;
  }

  getScheduledDate(parts) {
    const date = moment(`${parts.year}-${parts.month}-${parts.day}`, 'YYYY-MM-DD', true);
    return date.isValid() ? date.toDate() : null;
  }

  getRequiredDate(type) {
    const parts = {};
    ['day', 'month', 'year'].forEach(part => {
      parts[part] = this.schedulerForm.elements.namedItem(type + '_' + part).value;
    });
    return this.getScheduledDate(parts);
  }

  updateScheduledDate(type, parts) {
    const scheduledDates = {...this.state.scheduledDates, [type]: parts};
    const dropoff = this.getScheduledDate(scheduledDates.dropoff);
    const pickup = this.getScheduledDate(scheduledDates.pickup);
    const changedDate = type === 'dropoff' ? dropoff : pickup;
    const requiredDate = this.getRequiredDate(type);

    if (changedDate && requiredDate && changedDate > requiredDate) {
      window.alert(type === 'dropoff'
        ? 'Scheduled dropoff date cannot be later than the customer required service date.'
        : 'Scheduled pickup date cannot be later than the customer required pickup date.');
      return;
    }

    // Compare calendar dates only, once both scheduled dates are complete.
    if (dropoff && pickup && dropoff > pickup) {
      window.alert(type === 'dropoff'
        ? 'Scheduled dropoff date cannot be later than the scheduled pickup date.'
        : 'Scheduled pickup date cannot be earlier than the scheduled dropoff date.');
      return;
    }

    this.setState({scheduledDates});
  }

  handleScheduledDateSelectChange(type, part, value) {
    this.updateScheduledDate(type, {...this.state.scheduledDates[type], [part]: value});
  }

  handleScheduledDateCalendarChange(type, date) {
    if (!date) {
      return;
    }
    this.updateScheduledDate(type, {
      day: ('0' + date.getDate()).slice(-2),
      month: ('0' + (date.getMonth() + 1)).slice(-2),
      year: String(date.getFullYear()),
    });
  }

  handleScheduledDropoffDateCalendarChange(date) {
    this.handleScheduledDateCalendarChange('dropoff', date);
  }

  handleScheduledPickupDateCalendarChange(date) {
    this.handleScheduledDateCalendarChange('pickup', date);
  }

  postData(url = ``, data = {}) {
    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json'
      },
      redirect: "follow",
      referrer: "no-referrer",
      body: JSON.stringify(data),
    }).
    then(
      response => response //=> response.json()
    );
  }
  handleJobUpdate(
    save = true,
    saveAndSend = false
  ) {
    //this.state.job.unit.map((unit,index)=>{
      this.state.job.unit.date_of_event = (this.state.job.unit.date_of_event != null) ? moment(this.state.job.unit.date_of_event).format('YYYY-MM-DD HH:mm:ss'):null;
      this.state.job.unit.pickup_date = (this.state.job.unit.pickup_date) ? moment(this.state.job.unit.pickup_date).format('YYYY-MM-DD HH:mm:ss'):null;
      this.state.job.unit.dropoff_date = (this.state.job.unit.dropoff_date) ? moment(this.state.job.unit.dropoff_date).format('YYYY-MM-DD HH:mm:ss') : null;
      this.state.job.unit.required_date = (this.state.job.unit.required_date) ? moment(this.state.job.unit.required_date).format('YYYY-MM-DD HH:mm:ss') : null;
      this.state.job.unit.collection_date = (this.state.job.unit.collection_date) ? moment(this.state.job.unit.collection_date).format('YYYY-MM-DD HH:mm:ss') : null;
      this.state.job.unit.is_same_day_pickup_and_dropoff = (this.state.job.unit.is_same_day_pickup_and_dropoff) ? 1 : 0;
      this.state.job.unit.is_weekend_dropoff_pickup = (this.state.job.unit.is_weekend_dropoff_pickup) ? 1 : 0;
      this.state.job.unit.can_we_dropoff_in_week_before = (this.state.job.unit.can_we_dropoff_in_week_before) ? 1 : 0;
      this.state.job.unit.is_ongoing = (this.state.job.unit.is_ongoing) ? 1 :0;
    //});
    
    let savedJobData = {
      api_token: window.api_token,
      job_id: this.state.jobId,
      saved_driver_id: this.state.driver_id,
      driver_id: this.state.driver_id,
      customer_id: this.state.customer_id,

      pickup_preposition: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+' select[name=pickup_preposition]').value,
      pickup_day: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=pickup_day]').value,
      pickup_month: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=pickup_month]').value,
      pickup_year: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=pickup_year]').value,
      pickup_time: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=pickup_time]').value,

      dropoff_preposition: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=dropoff_preposition]').value,
      dropoff_day: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=dropoff_day]').value,
      dropoff_month: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=dropoff_month]').value,
      dropoff_year: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=dropoff_year]').value,
      dropoff_time: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=dropoff_time]').value,

      scheduled_pickup_preposition: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+' select[name=scheduled_pickup_preposition]').value,
      scheduled_pickup_day: document.querySelector('#job-scheduler-for-job-'+this.state.job.id+'  select[name=scheduled_pickup_day]').value,
      scheduled_pickup_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_month]'
      ).value,
      scheduled_pickup_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_year]'
      ).value,
      scheduled_pickup_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_time]'
      ).value,

      scheduled_dropoff_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_preposition]'
      ).value,
      scheduled_dropoff_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_day]'
      ).value,
      scheduled_dropoff_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_month]'
      ).value,
      scheduled_dropoff_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_year]'
      ).value,
      scheduled_dropoff_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_time]'
      ).value,


      customer_order_number: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=customer_order_number]'
      ).value,
      customer_job_number: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=customer_job_number]'
      ).value,

      fleet_paperwork_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_fleet_paperwork_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_fleet_paperwork_required]:checked'
      ).value : this.state.job.fleet_paperwork_required),

      jet_wash_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_jet_wash_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_jet_wash_required]:checked'
      ).value : this.state.job.jet_wash_required),

      manual_appraisal_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=manual_appraisal_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=manual_appraisal_required]:checked'
      ).value : this.state.job.manual_appraisal_required),

      video_appraisal_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=video_appraisal_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=video_appraisal_required]:checked'
      ).value : this.state.job.video_appraisal_required),

      appraisal_to_be_done_on_external_system: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=appraisal_to_be_done_on_external_system]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=appraisal_to_be_done_on_external_system]:checked'
      ).value : this.state.job.appraisal_to_be_done_on_external_system),

      name_of_external_system_for_appraisal: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=name_of_external_system_for_appraisal]'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=name_of_external_system_for_appraisal]'
      ).value : 0),

      fuel_included_in_job_price: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=driver_fuel_expense_included_in_job_price]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=driver_fuel_expense_included_in_job_price]:checked'
      ).value : this.state.job.fuel_included_in_job_price),

      recalculate_latt_and_long: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_latt_and_long'
      ).checked,
      recalculate_distance: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_distance'
      ).checked,
      recalculate_duration: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_duration'
      ).checked,
      recalculate_job_price: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_job_price'
      ).checked,
      recalculate_driver_price: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_driver_price'
      ).checked,

     unit:this.state.job.unit,

     customer_historical_notes: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=customer_historical_notes]'
      ).value,
      notes: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=notes]'
      ).value,

      pickup_address: {
        postcode: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_town_city]'
        ).value,
        county_area: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_county_area]'
        ).value,
        country: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_country]'
        ).value,
        opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_opening_times]'
        ).value,
        compound_opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_compound_opening_times]'
        ).value,
        contact_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_contact_name]'
        ).value,
        contact_telephone_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_contact_telephone_number]'
        ).value,
      },
      dropoff_address: {
        postcode: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_town_city]'
        ).value,
        county_area: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_county_area]'
        ).value,
        country: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_country]'
        ).value,
        opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_opening_times]'
        ).value,
        compound_opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_compound_opening_times]'
        ).value,
        contact_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_contact_name]'
        ).value,
        contact_telephone_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_contact_telephone_number]'
        ).value,
      },
    };
    
    if ((save === true) && (saveAndSend !== true)) {
      this.postData(
        '/api/v1/portal/jobs/save-job', savedJobData).
      then(response => {
        if (response.status === 400) {
          alert(response.json());
        }
      }).catch(error => {
          console.log(error);
          alert('Error saving job. Please check data and try again.');
        }
      );
    }

    if ((save === true) && (saveAndSend === true)) {
      this.postData('/api/v1/portal/jobs/plan-job', savedJobData).
      then(response => {
        if (response.status === 400) {
           response.json().then(responseText => {
            alert(responseText);
           });
        }
        else {
          this.props.schedulerHide();
        }
      }).
      catch(error => {
        console.log(error);
          alert('error sending job to driver. check data and try again.');
          $('#job-scheduler-modal').modal('modal');
        }
      );
    }
  }
  handleUnitTypeChange(e,index){
    this.state.job.unit.unit_type = e.target.value;
    this.setState({job:this.state.job});
  }
  handleUnitNumberChange(e,index){
    this.state.job.unit.unit_number = e.target.value;
    this.setState({job:this.state.job});
  }
  handleUnitQtyChange(e,index){
    this.state.job.unit.unit_qty = e.target.value;
    this.setState({job:this.state.job});
  }
  handleUnitDateOfEventChange(date,index){
    this.state.job.unit.date_of_event = date;
    this.setState({job:this.state.job});
  }
  handleUnitDropoffDateChange(date,index){
    this.state.job.unit.dropoff_date = date;
    this.setState({job:this.state.job});
  }
  handleUnitPickupDateChange(date,index){
    this.state.job.unit.pickup_date = date;
    this.setState({job:this.state.job});
  }
  handleIsSamedayPickupAndDRopoffChange(e,index){
    this.state.job.unit.is_same_day_pickup_and_dropoff = e.target.checked;
    this.setState({job:this.state.job});
  }
  handleIsWeekendDropoffPickupChange(e,index){
    this.state.job.unit.is_weekend_dropoff_pickup = e.target.checked;
    this.setState({job:this.state.job});
  }
  handleTypeofUnitService(e,index){
    this.state.job.unit.type_of_unit_service = e.target.value;
    this.setState({job:this.state.job});
  }
  handleNumberOfWeeksRequiredChange(e,index){
    this.state.job.unit.number_of_weeks_required = e.target.value;
    this.setState({job:this.state.job});
  }
  handleUnitRequiredDateChange(date,index){
    this.state.job.unit.required_date = date;
    this.setState({job:this.state.job});
  }
  handleUnitCollectionDateChange(date,index){
    this.state.job.unit.collection_date = date;
    this.setState({job:this.state.job});
  }
  handleCanweDropoffInWeekBeforeChange(e,index){
    this.state.job.unit.can_we_dropoff_in_week_before = e.target.checked;
    this.setState({job:this.state.job});
  }
  handleIsOngoingOptionChange(e,index){
    this.state.job.unit.is_ongoing = e.target.checked;
    this.setState({job:this.state.job});
  }
  render() {
    let Customers = [];
    let index = 0;
    let unit = "";
    if (this.state.job && !this.state.job.has_split_jobs) {
      unit = this.state.job.unit;
      index = this.state.job.unit ? this.state.job.unit.id : 0;
    }
    if (this.state.customers && this.state.job) {
      this.state.customers.forEach(function (i) {
        Customers.push(
          <option
            key={'customer-'+i.id}
            value={i.id}>
            {i.name}
          </option>);
      });
    }
    return (<div>
      {(this.state.job && this.state.job.id ?
        <div className="job-scheduler-modal">
          <div className="job-scheduler-modal-header">
          </div>
          <div className="job-scheduler-modal-body">
          <form
            ref={form => { this.schedulerForm = form; }}
            id={'job-scheduler-for-job-'+this.state.job.id}
            className="text-left schedule_job_form"
          >
            <fieldset>
              <h1 className="text-right">Job #{this.state.jobId}</h1>
              <div className="row">
                <div
                  className="col-md-4 text-right"
                  style={{'marginTop': '14px'}}>
                  <h2>Driver: </h2>
                </div>
                <div className="col-md-5 drivers-dropdown">
                  <DriversPowerSelect
                    handleDriverSelection={this.handleDriverSelection}
                    job={this.state.job}
                  />
                </div>
                <div className="col-md-3">
                  <div className="text-center">
                    <button
                      className="btn btn-lg btn-dark pull-right"
                      type="button"
                      data-toggle="collapse"
                      data-target="#scheduler-accordion"
                      aria-expanded="false"
                      aria-controls="scheduler-accordion"
                    ><i className="fa fa-cogs"></i> All Settings <i
                      className="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <br /><br />
              <div className="row">
                <div className="col-md-6">

                <h3>Customer Required Service Time <DatePicker
                  customInput={
                    <a className="btn btn-default">
                      <i className="far fa-calendar-alt"></i>
                    </a>
                  }
                  selected={this.state.dropoff_date}
                  onChange={this.handleDropoffDateCalendarChange}/></h3>
                <div className="input-group">
                  <select name="dropoff_preposition" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_preposition) ?
                            this.state.job.dropoff_preposition : ''}
                  >
                    <option value="?">?</option>
                    <option value="by">BY</option>
                    <option value="on">ON</option>
                    <option value="from">FROM</option>
                  </select>
                  &nbsp;:&nbsp;

                  <select name="dropoff_day" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_day) ?
                          this.state.job.dropoff_day : ''}
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="dropoff_month" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_month) ?
                            this.state.job.dropoff_month : ''}
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="dropoff_year" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_year) ?
                            this.state.job.dropoff_year : ''}
                  >
                    <option value="?">?</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                    <option value="2030">2030</option>
                  </select>
                  &nbsp;@&nbsp;
                  <select name="dropoff_time" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_time) ?
                            this.state.job.dropoff_time : ''}
                  >
                    <option value="?">?</option>
                    <option value="anytime">ANYTIME (9am-5pm)</option>
                    <option value="asap">ASAP</option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                    <option value="0700">7 AM</option>
                    <option value="0715">7:15 AM</option>
                    <option value="0730">7:30 AM</option>
                    <option value="0745">7:45 AM</option>
                    <option value="0800">8 AM</option>
                    <option value="0815">8:15 AM</option>
                    <option value="0830">8:30 AM</option>
                    <option value="0845">8:45 AM</option>
                    <option value="0900">9 AM</option>
                    <option value="0915">9:15 AM</option>
                    <option value="0930">9:30 AM</option>
                    <option value="0945">9:45 AM</option>
                    <option value="1000">10 AM</option>
                    <option value="1015">10:15 AM</option>
                    <option value="1030">10:30 AM</option>
                    <option value="1045">10:45 AM</option>
                    <option value="1100">11 AM</option>
                    <option value="1115">11:15 AM</option>
                    <option value="1130">11:30 AM</option>
                    <option value="1145">11:45 AM</option>
                    <option value="1200">12 PM</option>
                    <option value="1215">12:15 PM</option>
                    <option value="1230">12:30 PM</option>
                    <option value="1245">12:45 PM</option>
                    <option value="1300">1 PM</option>
                    <option value="1315">1:15 PM</option>
                    <option value="1330">1:30 PM</option>
                    <option value="1345">1:45 PM</option>
                    <option value="1400">2 PM</option>
                    <option value="1415">2:15 PM</option>
                    <option value="1430">2:30 PM</option>
                    <option value="1445">2:45 PM</option>
                    <option value="1500">3 PM</option>
                    <option value="1515">3:15 PM</option>
                    <option value="1530">3:30 PM</option>
                    <option value="1545">3:45 PM</option>
                    <option value="1600">4 PM</option>
                    <option value="1615">4:15 PM</option>
                    <option value="1630">4:30 PM</option>
                    <option value="1645">4:45 PM</option>
                    <option value="1700">5 PM</option>
                    <option value="1715">5:15 PM</option>
                    <option value="1730">5:30 PM</option>
                    <option value="1745">5:45 PM</option>
                    <option value="1800">6 PM</option>
                    <option value="1815">6:15 PM</option>
                    <option value="1830">6:30 PM</option>
                    <option value="1845">6:45 PM</option>
                    <option value="1900">7 PM</option>
                    <option value="1915">7:15 PM</option>
                    <option value="1930">7:30 PM</option>
                    <option value="1945">7:45 PM</option>
                    <option value="2000">8 PM</option>
                    <option value="2015">8:15 PM</option>
                    <option value="2030">8:30 PM</option>
                    <option value="2045">8:45 PM</option>
                    <option value="2100">9 PM</option>
                    <option value="2115">9:15 PM</option>
                    <option value="2130">9:30 PM</option>
                    <option value="2145">9:45 PM</option>
                    <option value="2200">10 PM</option>
                    <option value="2215">10:15 PM</option>
                    <option value="2230">10:30 PM</option>
                    <option value="2245">10:45 PM</option>
                    <option value="2300">11 PM</option>
                    <option value="2315">11:15 PM</option>
                    <option value="2330">11:30 PM</option>
                    <option value="2345">11:45 PM</option>
                    <option value="0000">MIDNIGHT</option>
                    <option value="0015">12:15 AM</option>
                    <option value="0030">12:30 AM</option>
                    <option value="0045">12:45 AM</option>
                    <option value="0100">1 AM</option>
                    <option value="0115">1:15 AM</option>
                    <option value="0130">1:30 AM</option>
                    <option value="0145">1:45 AM</option>
                    <option value="0200">2 AM</option>
                    <option value="0215">2:15 AM</option>
                    <option value="0230">2:30 AM</option>
                    <option value="0245">2:45 AM</option>
                    <option value="0300">3 AM</option>
                    <option value="0315">3:15 AM</option>
                    <option value="0330">3:30 AM</option>
                    <option value="0345">3:45 AM</option>
                    <option value="0400">4 AM</option>
                    <option value="0415">4:15 AM</option>
                    <option value="0430">4:30 AM</option>
                    <option value="0445">4:45 AM</option>
                    <option value="0500">5 AM</option>
                    <option value="0515">5:15 AM</option>
                    <option value="0530">5:30 AM</option>
                    <option value="0545">5:45 AM</option>
                    <option value="0600">6 AM</option>
                    <option value="0615">6:15 AM</option>
                    <option value="0630">6:30 AM</option>
                    <option value="0645">6:45 AM</option>
                  </select>
                </div>
                </div>
                <div className="col-md-6">
                <h3>
                  Customer Required Pickup Time <DatePicker
                  customInput={
                    <a className="btn btn-default">
                      <i className="far fa-calendar-alt"></i>
                    </a>
                  }
                  selected={this.state.pickup_date}
                  onChange={this.handlePickupDateCalendarChange}/>
                </h3>
                <div className="input-group">
                  <select name="pickup_preposition" required
                          defaultValue={(this.state.job.pickup_preposition) ?
                            this.state.job.pickup_preposition : ''}
                          className="timedropdown form-control"
                  >
                    <option value="?">?</option>
                    <option value="by">BY</option>
                    <option value="on">ON</option>
                    <option value="from">FROM</option>
                  </select>
                  &nbsp;:&nbsp;

                  <select name="pickup_day" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.pickup_day) ?
                            this.state.job.pickup_day : ''}
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="pickup_month" required
                          className="timedropdown form-control"
                          defaultValue={
                            (this.state.job.pickup_month) ?
                            this.state.job.pickup_month : ''
                          }
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  &nbsp;/&nbsp;

                  <select name="pickup_year" required
                          className="timedropdown form-control"
                          defaultValue={
                            (this.state.job.pickup_year) ?
                            this.state.job.pickup_year : ''
                          }
                  >
                    <option value="?">?</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                    <option value="2030">2030</option>
                  </select>
                  &nbsp;@&nbsp;

                  <select name="pickup_time" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.pickup_time) ?
                            this.state.job.pickup_time : ''
                          }
                  >
                    <option value="?">?</option>
                    <option value="anytime">ANYTIME (9am-5pm)</option>
                    <option value="asap">ASAP</option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                    <option value="0700">7 AM</option>
                    <option value="0715">7:15 AM</option>
                    <option value="0730">7:30 AM</option>
                    <option value="0745">7:45 AM</option>
                    <option value="0800">8 AM</option>
                    <option value="0815">8:15 AM</option>
                    <option value="0830">8:30 AM</option>
                    <option value="0845">8:45 AM</option>
                    <option value="0900">9 AM</option>
                    <option value="0915">9:15 AM</option>
                    <option value="0930">9:30 AM</option>
                    <option value="0945">9:45 AM</option>
                    <option value="1000">10 AM</option>
                    <option value="1015">10:15 AM</option>
                    <option value="1030">10:30 AM</option>
                    <option value="1045">10:45 AM</option>
                    <option value="1100">11 AM</option>
                    <option value="1115">11:15 AM</option>
                    <option value="1130">11:30 AM</option>
                    <option value="1145">11:45 AM</option>
                    <option value="1200">12 PM</option>
                    <option value="1215">12:15 PM</option>
                    <option value="1230">12:30 PM</option>
                    <option value="1245">12:45 PM</option>
                    <option value="1300">1 PM</option>
                    <option value="1315">1:15 PM</option>
                    <option value="1330">1:30 PM</option>
                    <option value="1345">1:45 PM</option>
                    <option value="1400">2 PM</option>
                    <option value="1415">2:15 PM</option>
                    <option value="1430">2:30 PM</option>
                    <option value="1445">2:45 PM</option>
                    <option value="1500">3 PM</option>
                    <option value="1515">3:15 PM</option>
                    <option value="1530">3:30 PM</option>
                    <option value="1545">3:45 PM</option>
                    <option value="1600">4 PM</option>
                    <option value="1615">4:15 PM</option>
                    <option value="1630">4:30 PM</option>
                    <option value="1645">4:45 PM</option>
                    <option value="1700">5 PM</option>
                    <option value="1715">5:15 PM</option>
                    <option value="1730">5:30 PM</option>
                    <option value="1745">5:45 PM</option>
                    <option value="1800">6 PM</option>
                    <option value="1815">6:15 PM</option>
                    <option value="1830">6:30 PM</option>
                    <option value="1845">6:45 PM</option>
                    <option value="1900">7 PM</option>
                    <option value="1915">7:15 PM</option>
                    <option value="1930">7:30 PM</option>
                    <option value="1945">7:45 PM</option>
                    <option value="2000">8 PM</option>
                    <option value="2015">8:15 PM</option>
                    <option value="2030">8:30 PM</option>
                    <option value="2045">8:45 PM</option>
                    <option value="2100">9 PM</option>
                    <option value="2115">9:15 PM</option>
                    <option value="2130">9:30 PM</option>
                    <option value="2145">9:45 PM</option>
                    <option value="2200">10 PM</option>
                    <option value="2215">10:15 PM</option>
                    <option value="2230">10:30 PM</option>
                    <option value="2245">10:45 PM</option>
                    <option value="2300">11 PM</option>
                    <option value="2315">11:15 PM</option>
                    <option value="2330">11:30 PM</option>
                    <option value="2345">11:45 PM</option>
                    <option value="0000">MIDNIGHT</option>
                    <option value="0015">12:15 AM</option>
                    <option value="0030">12:30 AM</option>
                    <option value="0045">12:45 AM</option>
                    <option value="0100">1 AM</option>
                    <option value="0115">1:15 AM</option>
                    <option value="0130">1:30 AM</option>
                    <option value="0145">1:45 AM</option>
                    <option value="0200">2 AM</option>
                    <option value="0215">2:15 AM</option>
                    <option value="0230">2:30 AM</option>
                    <option value="0245">2:45 AM</option>
                    <option value="0300">3 AM</option>
                    <option value="0315">3:15 AM</option>
                    <option value="0330">3:30 AM</option>
                    <option value="0345">3:45 AM</option>
                    <option value="0400">4 AM</option>
                    <option value="0415">4:15 AM</option>
                    <option value="0430">4:30 AM</option>
                    <option value="0445">4:45 AM</option>
                    <option value="0500">5 AM</option>
                    <option value="0515">5:15 AM</option>
                    <option value="0530">5:30 AM</option>
                    <option value="0545">5:45 AM</option>
                    <option value="0600">6 AM</option>
                    <option value="0615">6:15 AM</option>
                    <option value="0630">6:30 AM</option>
                    <option value="0645">6:45 AM</option>
                  </select>
                </div>
                </div>
              </div>
              <br /><br />
              <div className="row">
                <div className="col-md-6">
                  <h3>Scheduled Dropoff Time <DatePicker
                    customInput={
                      <a className="btn btn-default">
                        <i className="far fa-calendar-alt"></i>
                      </a>
                    }
                    selected={this.getScheduledDate(this.state.scheduledDates.dropoff)}
                    onChange={
                      this.handleScheduledDropoffDateCalendarChange
                    }
                  />
                  </h3>
                  <div className="input-group">
                    <select name="scheduled_dropoff_preposition" required
                            defaultValue='on'
                            className="timedropdown form-control"
                    >
                      <option value="on">ON</option>
                    </select>
                    &nbsp;:&nbsp;

                    <select name="scheduled_dropoff_day" required
                            className="timedropdown form-control"
                            value={this.state.scheduledDates.dropoff.day}
                            onChange={e => this.handleScheduledDateSelectChange('dropoff', 'day', e.target.value)}
                    >
                      <option value="?">?</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">31</option>
                    </select>
                    &nbsp;/&nbsp;
                    <select
                      name="scheduled_dropoff_month"
                      required
                      className="timedropdown form-control"
                      value={this.state.scheduledDates.dropoff.month}
                      onChange={e => this.handleScheduledDateSelectChange('dropoff', 'month', e.target.value)}
                    >
                      <option value="?">?</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    &nbsp;/&nbsp;
                    <select
                      name="scheduled_dropoff_year"
                      required
                      className="timedropdown form-control"
                      value={this.state.scheduledDates.dropoff.year}
                      onChange={e => this.handleScheduledDateSelectChange('dropoff', 'year', e.target.value)}
                    >
                      <option value="?">?</option>
                      <option value="2019">2019</option>
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                      <option value="2029">2029</option>
                      <option value="2030">2030</option>
                    </select>
                    &nbsp;@&nbsp;
                    <select
                      name="scheduled_dropoff_time"
                      required
                      className="timedropdown form-control"
                      defaultValue={(this.state.job.scheduled_dropoff_time) ?
                      this.state.job.scheduled_dropoff_time : ''}
                    >
                      <option value="?">?</option>
                      <option value="anytime">ANYTIME (9am-5pm)</option>
                      <option value="asap">ASAP</option>
                      <option value="am">AM</option>
                      <option value="pm">PM</option>
                      <option value="0700">7 AM</option>
                      <option value="0715">7:15 AM</option>
                      <option value="0730">7:30 AM</option>
                      <option value="0745">7:45 AM</option>
                      <option value="0800">8 AM</option>
                      <option value="0815">8:15 AM</option>
                      <option value="0830">8:30 AM</option>
                      <option value="0845">8:45 AM</option>
                      <option value="0900">9 AM</option>
                      <option value="0915">9:15 AM</option>
                      <option value="0930">9:30 AM</option>
                      <option value="0945">9:45 AM</option>
                      <option value="1000">10 AM</option>
                      <option value="1015">10:15 AM</option>
                      <option value="1030">10:30 AM</option>
                      <option value="1045">10:45 AM</option>
                      <option value="1100">11 AM</option>
                      <option value="1115">11:15 AM</option>
                      <option value="1130">11:30 AM</option>
                      <option value="1145">11:45 AM</option>
                      <option value="1200">12 PM</option>
                      <option value="1215">12:15 PM</option>
                      <option value="1230">12:30 PM</option>
                      <option value="1245">12:45 PM</option>
                      <option value="1300">1 PM</option>
                      <option value="1315">1:15 PM</option>
                      <option value="1330">1:30 PM</option>
                      <option value="1345">1:45 PM</option>
                      <option value="1400">2 PM</option>
                      <option value="1415">2:15 PM</option>
                      <option value="1430">2:30 PM</option>
                      <option value="1445">2:45 PM</option>
                      <option value="1500">3 PM</option>
                      <option value="1515">3:15 PM</option>
                      <option value="1530">3:30 PM</option>
                      <option value="1545">3:45 PM</option>
                      <option value="1600">4 PM</option>
                      <option value="1615">4:15 PM</option>
                      <option value="1630">4:30 PM</option>
                      <option value="1645">4:45 PM</option>
                      <option value="1700">5 PM</option>
                      <option value="1715">5:15 PM</option>
                      <option value="1730">5:30 PM</option>
                      <option value="1745">5:45 PM</option>
                      <option value="1800">6 PM</option>
                      <option value="1815">6:15 PM</option>
                      <option value="1830">6:30 PM</option>
                      <option value="1845">6:45 PM</option>
                      <option value="1900">7 PM</option>
                      <option value="1915">7:15 PM</option>
                      <option value="1930">7:30 PM</option>
                      <option value="1945">7:45 PM</option>
                      <option value="2000">8 PM</option>
                      <option value="2015">8:15 PM</option>
                      <option value="2030">8:30 PM</option>
                      <option value="2045">8:45 PM</option>
                      <option value="2100">9 PM</option>
                      <option value="2115">9:15 PM</option>
                      <option value="2130">9:30 PM</option>
                      <option value="2145">9:45 PM</option>
                      <option value="2200">10 PM</option>
                      <option value="2215">10:15 PM</option>
                      <option value="2230">10:30 PM</option>
                      <option value="2245">10:45 PM</option>
                      <option value="2300">11 PM</option>
                      <option value="2315">11:15 PM</option>
                      <option value="2330">11:30 PM</option>
                      <option value="2345">11:45 PM</option>
                      <option value="0000">MIDNIGHT</option>
                      <option value="0015">12:15 AM</option>
                      <option value="0030">12:30 AM</option>
                      <option value="0045">12:45 AM</option>
                      <option value="0100">1 AM</option>
                      <option value="0115">1:15 AM</option>
                      <option value="0130">1:30 AM</option>
                      <option value="0145">1:45 AM</option>
                      <option value="0200">2 AM</option>
                      <option value="0215">2:15 AM</option>
                      <option value="0230">2:30 AM</option>
                      <option value="0245">2:45 AM</option>
                      <option value="0300">3 AM</option>
                      <option value="0315">3:15 AM</option>
                      <option value="0330">3:30 AM</option>
                      <option value="0345">3:45 AM</option>
                      <option value="0400">4 AM</option>
                      <option value="0415">4:15 AM</option>
                      <option value="0430">4:30 AM</option>
                      <option value="0445">4:45 AM</option>
                      <option value="0500">5 AM</option>
                      <option value="0515">5:15 AM</option>
                      <option value="0530">5:30 AM</option>
                      <option value="0545">5:45 AM</option>
                      <option value="0600">6 AM</option>
                      <option value="0615">6:15 AM</option>
                      <option value="0630">6:30 AM</option>
                      <option value="0645">6:45 AM</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <h3>Scheduled Pickup Time <DatePicker
                    customInput={
                      <a className="btn btn-default">
                        <i className="far fa-calendar-alt"></i>
                      </a>
                    }
                    selected={this.getScheduledDate(this.state.scheduledDates.pickup)}
                    onChange={this.handleScheduledPickupDateCalendarChange}/></h3>
                  <div className="input-group">
                    <select name="scheduled_pickup_preposition" required
                            className="timedropdown form-control"
                            defaultValue='on'
                    >
                      <option value="on">ON</option>
                    </select>
                    &nbsp;:&nbsp;

                    <select name="scheduled_pickup_day" required
                            className="timedropdown form-control"
                            value={this.state.scheduledDates.pickup.day}
                            onChange={e => this.handleScheduledDateSelectChange('pickup', 'day', e.target.value)}

                    >
                      <option value="?">?</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">31</option>
                    </select>
                    &nbsp;/&nbsp;
                    <select
                      name="scheduled_pickup_month"
                      required
                      className="timedropdown form-control"
                      value={this.state.scheduledDates.pickup.month}
                      onChange={e => this.handleScheduledDateSelectChange('pickup', 'month', e.target.value)}
                    >
                      <option value="?">?</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    &nbsp;/&nbsp;

                    <select name="scheduled_pickup_year" required
                            className="timedropdown form-control"
                            value={this.state.scheduledDates.pickup.year}
                            onChange={e => this.handleScheduledDateSelectChange('pickup', 'year', e.target.value)}
                    >
                      <option value="?">?</option>
                      <option value="2019">2019</option>
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                      <option value="2029">2029</option>
                      <option value="2030">2030</option>
                    </select>
                    &nbsp;@&nbsp;

                    <select name="scheduled_pickup_time" required
                            className="timedropdown form-control"
                            defaultValue={(this.state.job.scheduled_pickup_time) ?
                              this.state.job.scheduled_pickup_time : ''}
                    >
                      <option value="?">?</option>
                      <option value="anytime">ANYTIME (9am-5pm)</option>
                      <option value="asap">ASAP</option>
                      <option value="am">AM</option>
                      <option value="pm">PM</option>
                      <option value="0700">7 AM</option>
                      <option value="0715">7:15 AM</option>
                      <option value="0730">7:30 AM</option>
                      <option value="0745">7:45 AM</option>
                      <option value="0800">8 AM</option>
                      <option value="0815">8:15 AM</option>
                      <option value="0830">8:30 AM</option>
                      <option value="0845">8:45 AM</option>
                      <option value="0900">9 AM</option>
                      <option value="0915">9:15 AM</option>
                      <option value="0930">9:30 AM</option>
                      <option value="0945">9:45 AM</option>
                      <option value="1000">10 AM</option>
                      <option value="1015">10:15 AM</option>
                      <option value="1030">10:30 AM</option>
                      <option value="1045">10:45 AM</option>
                      <option value="1100">11 AM</option>
                      <option value="1115">11:15 AM</option>
                      <option value="1130">11:30 AM</option>
                      <option value="1145">11:45 AM</option>
                      <option value="1200">12 PM</option>
                      <option value="1215">12:15 PM</option>
                      <option value="1230">12:30 PM</option>
                      <option value="1245">12:45 PM</option>
                      <option value="1300">1 PM</option>
                      <option value="1315">1:15 PM</option>
                      <option value="1330">1:30 PM</option>
                      <option value="1345">1:45 PM</option>
                      <option value="1400">2 PM</option>
                      <option value="1415">2:15 PM</option>
                      <option value="1430">2:30 PM</option>
                      <option value="1445">2:45 PM</option>
                      <option value="1500">3 PM</option>
                      <option value="1515">3:15 PM</option>
                      <option value="1530">3:30 PM</option>
                      <option value="1545">3:45 PM</option>
                      <option value="1600">4 PM</option>
                      <option value="1615">4:15 PM</option>
                      <option value="1630">4:30 PM</option>
                      <option value="1645">4:45 PM</option>
                      <option value="1700">5 PM</option>
                      <option value="1715">5:15 PM</option>
                      <option value="1730">5:30 PM</option>
                      <option value="1745">5:45 PM</option>
                      <option value="1800">6 PM</option>
                      <option value="1815">6:15 PM</option>
                      <option value="1830">6:30 PM</option>
                      <option value="1845">6:45 PM</option>
                      <option value="1900">7 PM</option>
                      <option value="1915">7:15 PM</option>
                      <option value="1930">7:30 PM</option>
                      <option value="1945">7:45 PM</option>
                      <option value="2000">8 PM</option>
                      <option value="2015">8:15 PM</option>
                      <option value="2030">8:30 PM</option>
                      <option value="2045">8:45 PM</option>
                      <option value="2100">9 PM</option>
                      <option value="2115">9:15 PM</option>
                      <option value="2130">9:30 PM</option>
                      <option value="2145">9:45 PM</option>
                      <option value="2200">10 PM</option>
                      <option value="2215">10:15 PM</option>
                      <option value="2230">10:30 PM</option>
                      <option value="2245">10:45 PM</option>
                      <option value="2300">11 PM</option>
                      <option value="2315">11:15 PM</option>
                      <option value="2330">11:30 PM</option>
                      <option value="2345">11:45 PM</option>
                      <option value="0000">MIDNIGHT</option>
                      <option value="0015">12:15 AM</option>
                      <option value="0030">12:30 AM</option>
                      <option value="0045">12:45 AM</option>
                      <option value="0100">1 AM</option>
                      <option value="0115">1:15 AM</option>
                      <option value="0130">1:30 AM</option>
                      <option value="0145">1:45 AM</option>
                      <option value="0200">2 AM</option>
                      <option value="0215">2:15 AM</option>
                      <option value="0230">2:30 AM</option>
                      <option value="0245">2:45 AM</option>
                      <option value="0300">3 AM</option>
                      <option value="0315">3:15 AM</option>
                      <option value="0330">3:30 AM</option>
                      <option value="0345">3:45 AM</option>
                      <option value="0400">4 AM</option>
                      <option value="0415">4:15 AM</option>
                      <option value="0430">4:30 AM</option>
                      <option value="0445">4:45 AM</option>
                      <option value="0500">5 AM</option>
                      <option value="0515">5:15 AM</option>
                      <option value="0530">5:30 AM</option>
                      <option value="0545">5:45 AM</option>
                      <option value="0600">6 AM</option>
                      <option value="0615">6:15 AM</option>
                      <option value="0630">6:30 AM</option>
                      <option value="0645">6:45 AM</option>
                    </select>
                  </div>
                </div>
              </div>
              <br /><br />
              <div id="scheduler-accordion" className="collapse">
                <div className="row">
                  <div className="col-md-2">
                    <h3>Customer</h3>
                    <select
                      className="form-control form-control-lg"
                      name="customer_id"
                      value={this.state.customer_id || ''}
                      onChange={(e) => {
                        this.setState({
                          customer_id: e.target.value
                        });
                      }}>
                      {Customers}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>
                      <small>Customer Order Number</small>
                    </label>
                    <input
                      type="text"
                      name="customer_order_number"
                      className="form-control form-control-lg"
                      defaultValue={this.state.job.customer_order_number || ''}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>
                      <small>Customer Job Number</small>
                    </label>
                    <input
                      type="text"
                      name="customer_job_number"
                      className="form-control form-control-lg"
                      defaultValue={this.state.job.customer_job_number || ''}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                              Waste Transfer Note required?
                          </label>

                          <div
                            className="btn-group btn-group-toggle"
                            id="fleet-paperwork-form-radio-container"
                            data-toggle="buttons">
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              (this.state.job.fleet_paperwork_required === 1)
                                ?
                                ' active '
                                : ''
                            )
                            }
                              id="yes-fleet-paperwork">
                              <input
                                className="form-control form-control-lg"
                                name="vehicle_fleet_paperwork_required"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              (this.state.job.fleet_paperwork_required === 0)
                                ?
                                ' active '
                                : ''
                            )
                            }
                                   id="no-fleet-paperwork">
                              <input className="form-control form-control-lg"
                                     name="vehicle_fleet_paperwork_required"
                                     type="radio" value="0" required/> NO
                            </label>
                          </div>
                          {/* <div className="form-group">
                            <label>
                              Jet Wash required?
                            </label>
                            <div
                              className="btn-group btn-group-toggle"
                              id="jet-wash-form-radio-container"
                              data-toggle="buttons">
                              <label className={"btn btn-secondary" + (
                                this.state.job &&
                                this.state.job.jet_wash_required === 1
                                  ?
                                  ' active '
                                  : ''
                              )
                              }
                                     id="yes-jet-wash">
                                <input
                                  className="form-control form-control-lg"
                                  name="vehicle_jet_wash_required"
                                  type="radio"
                                  value="1"
                                  required
                                /> YES
                              </label>
                              <label className={"btn btn-secondary" + (
                                this.state.job &&
                                this.state.job.jet_wash_required === 0
                                  ?
                                  ' active '
                                  : ''
                              )
                              }
                                     id="no-jet-wash">
                                <input
                                  className="form-control form-control-lg"
                                  name="vehicle_jet_wash_required"
                                  type="radio"
                                  value="0"
                                  required
                                /> NO
                              </label>
                            </div>
                          </div> */}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Manual Appraisal Required?
                          </label>
                          <div
                            className="btn-group btn-group-toggle"
                            id="manual-appraisal-required-form-radio-container"
                            data-toggle="buttons">
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              this.state.job.manual_appraisal_required === 1
                                ?
                                ' active '
                                : ''
                            )
                            }
                              id="yes-manual-appraisal-required">
                              <input
                                className="form-control form-control-lg"
                                name="manual_appraisal_required"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label
                              className={"btn btn-secondary" + (
                              this.state.job &&
                              this.state.job.manual_appraisal_required === 0
                                ?
                                ' active '
                                : ''
                            )
                            }
                              id="no-manual-appraisal-required">
                              <input
                                className="form-control form-control-lg"
                                name="manual_appraisal_required"
                                type="radio"
                                value="0"
                                required
                              /> NO
                            </label>
                          </div>
                        </div>
                        {/* <div className="form-group">
                          <label>
                            Video Appraisal Required?
                          </label>
                          <div
                            className="btn-group btn-group-toggle"
                            id="video-appraisal-required-form-radio-container"
                            data-toggle="buttons">
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              this.state.job.video_appraisal_required === 1
                                ?
                                ' active '
                                : ''
                            )
                            }
                                   id="yes-video-appraisal-required">
                              <input
                                className="form-control form-control-lg"
                                name="video_appraisal_required"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label
                              className={"btn btn-secondary" + (
                                this.state.job &&
                                this.state.job.video_appraisal_required === 0
                                  ?
                                  ' active '
                                  : ''
                              )
                              }
                              id="no-video-appraisal-required">
                              <input
                                className="form-control form-control-lg"
                                name="video_appraisal_required"
                                type="radio"
                                value="0"
                                required
                              /> NO
                            </label>
                          </div>
                        </div> */}
                        {/* <div className="form-group">
                          <label>
                            Appraisal To Be Done on External System?
                          </label>
                          <div
                            className="btn-group btn-group-toggle"
                            id="appraisal-to-be-done-on-external-system-form-radio-container"
                            data-toggle="buttons">
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              this.state.job.appraisal_to_be_done_on_external_system === 1
                                ?
                                ' active '
                                : ''
                            )
                            }
                                   id="yes-appraisal-to-be-done-on-external-system">
                              <input
                                className="form-control form-control-lg"
                                name="appraisal_to_be_done_on_external_system"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label
                              className={"btn btn-secondary" + (
                                this.state.job &&
                                this.state.job.appraisal_to_be_done_on_external_system === 0
                                  ?
                                  ' active '
                                  : ''
                              )
                              }
                              id="no-appraisal-to-be-done-on-external-system">
                              <input
                                className="form-control form-control-lg"
                                name="appraisal_to_be_done_on_external_system"
                                type="radio"
                                value="0"
                                required
                              /> NO
                            </label>
                          </div>
                        </div> */}
                        {/* <div className="form-group">
                          <label>Name of System for External Appraisal</label>
                          <input
                            type="text"
                            className="form-control form-control-lg"
                            name="name_of_external_system_for_appraisal"
                            defaultValue={this.state.job.name_of_external_system_for_appraisal}
                            />

                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="row row-spacer-1">
                  <div className="col-md-12">
                    <h3>Job Financials</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Admin Fee
                      </label>
                      <CurrencyInput
                        type="text"
                        name="funds"
                        value={this.state.job_admin_fee_in_pence / 100}
                        prefix={'£'}
                        type='text'
                        allowNegative={true}
                        className="form-control form-control-lg form-control-currency"
                        onChangeEvent={
                          (event, maskedValue, floatValue) => {
                            this.setState({
                              job_admin_fee_in_pence: (floatValue * 100),
                              job_admin_fee_in_pence_formatted: maskedValue,
                            });
                          }
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3">
                    <div className="form-group text-center">
                      <p>
                        Fuel Included in Job Price?
                      </p>

                      <div
                        className="btn-group btn-group-toggle"
                        id="yes-driver-fuel-expense-included-in-job-price-form-radio-container"
                        data-toggle="buttons">
                        <label className={"btn btn-secondary" + (
                          this.state.job &&
                          this.state.job.fuel_included_in_job_price === 1
                            ?
                            ' active '
                            : ''
                        )
                               }
                               id="yes-driver-fuel-expense-included-in-job-price">
                          <input className="form-control form-control-lg"
                                 name="driver_fuel_expense_included_in_job_price"
                                 type="radio" value="1"/> YES
                        </label>
                        <label className={"btn btn-secondary" + (
                          this.state.job &&
                          this.state.job.fuel_included_in_job_price === 0
                            ?
                            ' active '
                            : ''
                        )
                               }
                               id="no-driver-fuel-expense-included-in-job-price">
                          <input className="form-control form-control-lg"
                                 name="driver_fuel_expense_included_in_job_price"
                                 type="radio" value="0"/> NO
                        </label>
                      </div>
                    </div>
                  </div>
                </div> */}
                { (!this.state.job.has_split_jobs) ? 
                <div className="row">
                  <div className="col-md-12">
                    <br/>
                    <h3>Unit Details</h3>
                  </div>
                </div>
                : null }

              { (!this.state.job.has_split_jobs) ? 
                <div className="row">
                  {/* {
                    this.state.job.unit.map((unit,index)=>{
                      return( */}
                      <div className="row col-md-12" key={index}>
                          <div className="col-md-2 col-sm-12">
                            <label>Type of Unit</label>
                            <select name="unit_type" required="required" className="form-control unit-services-dropdown" value={unit ? unit.unit_type : ''} onChange={(e)=>this.handleUnitTypeChange(e,index)}>
                                <option value="">Select Type</option>
                                <option value="ace">Ace</option>
                                <option value="basic">Basic</option>
                                <option value="hand_wash">Hand wash</option>
                                <option value="disabled">Disabled</option>
                                <option value="urinal">Urinal</option>
                                <option value="eagle_plant_own_service">Eagle plant own service</option>
                                <option value="a1_own_service">A1 own service</option>
                                <option value="shower">Shower</option>
                                <option value="delivery_charge">Delivery Charge</option>
                                <option value="waste_hire">Waste Hire</option>
                                <option value="wash_station">Wash Station</option>
                                <option value="tressick_toilet" disabled={(unit && unit.unit_term == 'long') ? false:true}>Tressick Toilet</option>
                                <option value="tressick_toilet_extra_service" disabled={(unit && unit.unit_term == 'long') ? false:true}>Tressick Toilet Extra Service</option>
                                <option value="one_off_service" disabled={(unit && unit.unit_term == 'long') ? true:false}>One Off Service</option>
                                <option value="welfare" disabled={(unit && unit.unit_term == 'short') ? true:false}>Welfare</option>
                                <option value="own_unit_service" disabled={(unit && unit.unit_term == 'short') ? true:false}>Own Unit Service</option>
                                <option value="service" disabled={(unit && unit.unit_term == 'short') ? true:false}>Service</option>
                                <option value="hire_and_service" disabled={(unit && unit.unit_term == 'short') ? true:false}>Hire and Service</option>
                                <option value="hire_only" disabled={(unit && unit.unit_term == 'short') ? true:false}>Hire Only</option>
                              </select>
                          </div>
                          <div className="col-md-2">
                              <label>Unit number</label>
                              <input type="text" className="form-control form-control-lg"
                                placeholder="Unit Number"
                                name="unit_number"
                                value={unit && unit.unit_number ? unit.unit_number : ''}
                                id="unit_number" onChange={(e)=>this.handleUnitNumberChange(e,index)} />
                          </div>
                          <div className="col-md-2">
                              <label>Unit Qty</label>
                              <input type="number" className="form-control form-control-lg"
                                placeholder="Unit Qty"
                                min="1"
                                value={unit && unit.unit_qty ? unit.unit_qty : ''}
                                name="unit_qty"
                                id="unit_qty" onChange={(e)=>this.handleUnitQtyChange(e,index)} />
                            </div>
                            <div className={(unit && unit.unit_term == 'long') ? "col-md-2 col-sm-12 unit-type-of-service-container" : "col-md-2 col-sm-12 unit-type-of-service-container toggle-hide"}>
                                <label>Type of Service</label>
                                <select name="type_of_unit_service" value={unit && unit.type_of_unit_service ? unit.type_of_unit_service : ''} className="form-control  unit-services-dropdown" onChange={(e)=>this.handleTypeofUnitService(e,index)}>
                                  <option value="daily">Daily</option>
                                  <option value="weekly">Weekly</option>
                                  <option value="fortnightly" disabled={(unit && unit.unit_type == "welfare") ? true :false}>Fortnightly </option>
                                  <option value="monthly" disabled={(unit && unit.unit_type == "welfare") ? true :false}>Monthly </option>
                                </select>
                            </div>
                            <div className={(unit && unit.unit_term == 'long') ? "col-md-2" : "col-md-2 toggle-hide"}>
                              <label>Number of weeks required</label>
                              <input type="number" className="form-control form-control-lg"
                                placeholder="Number of weeks"
                                min="1"
                                value={unit && unit.number_of_weeks_required ? unit.number_of_weeks_required : ''}
                                name="number_of_weeks_required"
                                id="number_of_weeks_required" onChange={(e)=>this.handleNumberOfWeeksRequiredChange(e,index)} />
                            </div>
                            <div className={(unit && unit.unit_term == 'long') ?"col-md-2 col-sm-12" : "col-md-2 col-sm-12 toggle-hide"}>
                              <label>Required Date</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Required Date" selected={(unit && unit.required_date)  ? moment(unit && unit.required_date).toDate() : ""} onChange={date=>this.handleUnitRequiredDateChange(date,index)} />
                            </div>
                            <div className={(unit && unit.unit_term == 'long') ? "col-md-2 col-sm-12" : "col-md-2 col-sm-12 toggle-hide"}>
                              <label>Collection Date</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Collection Date" selected={(unit && unit.collection_date) ? moment(unit && unit.collection_date).toDate() : ""} onChange={date=>this.handleUnitCollectionDateChange(date,index)} />
                            </div>
                            <div className={(unit && unit.unit_term == 'long') ? "col-md-4 col-sm-12 checkbox-custom-group":"col-md-4 col-sm-12 checkbox-custom-group toggle-hide"}>
                              <div className="pdtop-25">
                                <label>
                                  <input type="checkbox" className="checkbox-custom" name="can_we_dropoff_in_week_before" defaultChecked={unit && unit.can_we_dropoff_in_week_before} value={unit && unit.can_we_dropoff_in_week_before ? unit.can_we_dropoff_in_week_before : ""} onChange={(e)=>this.handleCanweDropoffInWeekBeforeChange(e,index)}/>
                                      &nbsp;&nbsp;Can we drop off in the week before ?
                                  </label>
                              </div>
                            </div>
                            <div className={(unit && unit.unit_term == 'long') ? "col-md-2 col-sm-12 checkbox-custom-group":"col-md-2 col-sm-12 checkbox-custom-group toggle-hide"}>
                              <div className="pdtop-25">
                                <label>
                                  <input type="checkbox" className="checkbox-custom" name="is_ongoing" defaultChecked={unit && unit.is_ongoing} value={unit && unit.is_ongoing ? unit.is_ongoing : ""} onChange={(e)=>this.handleIsOngoingOptionChange(e,index)}/>
                                      &nbsp;&nbsp;Ongoing ?
                                  </label>
                              </div>
                            </div>
                            <div className={(unit && unit.unit_term == 'short') ? "col-md-2 col-sm-12":"col-md-2 col-sm-12 toggle-hide"}>
                              <label>Date of Event</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Date of Event" selected={(unit && unit.date_of_event) ? moment(unit && unit.date_of_event).toDate() : ""} onChange={date=>this.handleUnitDateOfEventChange(date,index)} />
                            </div>
                            <div className={(unit && unit.unit_term == 'short') ? "col-md-2 col-sm-12":"col-md-2 col-sm-12 toggle-hide"}>
                              <label>Dropoff Date</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Dropoff Date" selected={(unit && unit.dropoff_date) ? moment(unit && unit.dropoff_date).toDate() : ""} onChange={date=>this.handleUnitDropoffDateChange(date,index)} />
                            </div>
                            <div className={(unit && unit.unit_term == 'short') ? "col-md-2 col-sm-12" : "col-md-2 col-sm-12 toggle-hide"}>
                              <label>Pickup Date</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Pickup Date" selected={(unit && unit.pickup_date) ? moment(unit && unit.pickup_date).toDate() : ""} onChange={date=>this.handleUnitPickupDateChange(date,index)} />
                            </div>
                            <div className={(unit && unit.unit_term == 'short') ? "col-md-3 col-sm-12 checkbox-custom-group" : "col-md-3 col-sm-12 checkbox-custom-group toggle-hide"}>
                              <div>
                                <label><input type="checkbox" className="checkbox-custom" name="is_same_day_pickup_and_dropoff" defaultChecked={unit && unit.is_same_day_pickup_and_dropoff} value={unit && unit.is_same_day_pickup_and_dropoff ? unit.is_same_day_pickup_and_dropoff : ""} onChange={(e)=>this.handleIsSamedayPickupAndDRopoffChange(e,index)} />&nbsp;&nbsp;Same day pick up and drop off ?</label>
                              </div>
                            </div>
                            <div className={(unit && unit.unit_term == 'short') ? "col-md-3 col-sm-12 checkbox-custom-group" : "col-md-3 col-sm-12 checkbox-custom-group toggle-hide"}>
                              <div>
                                <label><input type="checkbox" className="checkbox-custom" name="is_weekend_dropoff_pickup" defaultChecked={unit && unit.is_weekend_dropoff_pickup} value={unit && unit.is_weekend_dropoff_pickup ? unit.is_weekend_dropoff_pickup : ""} onChange={(e)=>this.handleIsWeekendDropoffPickupChange(e,index)}/>&nbsp;&nbsp;Weekend drop off/ pick up ?</label>
                              </div>
                            </div>
                      </div>
                      {/* )
                    })
                  } */}
                </div>
                : null }
                <br/>
                <div className="row">
                  {/* <div className="col-md-6">
                    <label htmlFor="special_instructions">
                      Special Instructions:
                    </label>
                    <textarea
                      className="form-control form-control-lg text-center"
                      name="special_instructions"
                      defaultValue={this.state.job.special_instructions}
                       id="special_instructions">
                    </textarea>
                  </div> */}
                  <div className="col-md-6">
                    <label htmlFor="notes">Special Instructions:</label>
                    <textarea
                      className="form-control form-control-lg text-center"
                      name="customer_historical_notes"
                      rows={6}
                      defaultValue={this.state.job.customer.customer_historical_notes}
                      id="customer_historical_notes">
                    </textarea>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="notes">Notes:</label>
                    <textarea
                      className="form-control form-control-lg text-center"
                      name="notes"
                      defaultValue={this.state.job.notes}
                      id="notes">
                    </textarea>
                  </div>
                </div>
                <br /><br />
                <div className="row">
                  <div className="col-md-6">
                    <br/>
                    <br/>
                    <h3>Yard Address</h3>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_house_number_or_name">
                          House Number or Name:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_house_number_or_name"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.house_number_or_name) ?
                             this.state.job.pickup_address.house_number_or_name : ''
                          }
                          id="pickup_address_house_number_or_name"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_address_line_1">
                          Address Line 1:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_address_line_1"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.address_line_1) ?
                              this.state.job.pickup_address.address_line_1 : ''
                          }
                          id="pickup_address_address_line_1"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_address_line_2">
                          Address Line 2:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_address_line_2"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.address_line_2) ?
                              this.state.job.pickup_address.address_line_2 : ''
                          }
                          id="pickup_address_address_line_2"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_address_line_3">
                          Address Line 3:</label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_address_line_3"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.address_line_3) ?
                             this.state.job.pickup_address.address_line_3 : ''
                          }
                          id="pickup_address_address_line_3"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_town_city">
                          Town/City:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_town_city"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.town_city) ?
                              this.state.job.pickup_address.town_city : ''
                          }
                          id="pickup_address_town_city"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="pickup_address_county_area"
                        >
                          County/Area
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_county_area"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.county_area) ?
                              this.state.job.pickup_address.county_area : ''
                          }
                          id="pickup_address_county_area"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="pickup_address_country"
                          required
                        >
                          Country:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_country"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.country) ?
                              this.state.job.pickup_address.country : ''
                          }
                          id="pickup_address_country"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_postcode">
                          Postcode:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_postcode"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.postcode) ?
                              this.state.job.pickup_address.postcode : ''
                          }
                          id="pickup_address_postcode"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_opening_times">
                          Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_opening_times"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.opening_times) ?
                             this.state.job.pickup_address.opening_times : ''
                          }
                          id="pickup_address_opening_times"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_compound_opening_times">
                          Compound Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_compound_opening_times"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.compound_opening_times) ?
                             this.state.job.pickup_address.compound_opening_times : ''
                          }
                          id="pickup_address_compound_opening_times"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_contact_name">
                          Contact Name:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_contact_name"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.contact_name) ?
                             this.state.job.pickup_address.contact_name : ''
                          }
                          id="pickup_address_contact_name"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="pickup_address_contact_telephone_number"
                        >
                          Contact Telephone Number:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_contact_telephone_number"
                          defaultValue={(
                            this.state.job.pickup_address &&
                            this.state.job.pickup_address.contact_telephone_number) ?
                            this.state.job.pickup_address.contact_telephone_number : ''
                          }
                          id="pickup_address_contact_telephone_number"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h3>Service Address</h3>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_house_number_or_name">
                          House Number or Name:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_house_number_or_name"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.house_number_or_name) ?
                            this.state.job.dropoff_address.house_number_or_name : ''
                          }
                          id="dropoff_address_house_number_or_name"
                          className="form-control form-control-lg"/>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_address_line_1">
                          Address Line 1:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_address_line_1"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.address_line_1) ?
                            this.state.job.dropoff_address.address_line_1 : ''
                          }
                          id="dropoff_address_address_line_1"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_address_line_2">
                          Address Line 2:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_address_line_2"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.address_line_2)
                            ? this.state.job.dropoff_address.address_line_2
                            : ''
                          }
                          id="dropoff_address_address_line_2"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_address_line_3">
                          Address Line 3:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_address_line_3"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.address_line_3)
                            ? this.state.job.dropoff_address.address_line_3
                            : ''
                          }
                          id="dropoff_address_address_line_3"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_town_city">
                          Town/City:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_town_city"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.town_city)
                            ? this.state.job.dropoff_address.town_city
                            : ''
                          }
                          id="dropoff_address_town_city"
                          required
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="dropoff_address_county_area"
                          required
                        >
                          County/Area
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_county_area"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.county_area)
                            ? this.state.job.dropoff_address.county_area
                            : ''
                          }
                          id="dropoff_address_county_area"
                          required
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="dropoff_address_country"
                          required
                        >
                          Country:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_country"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.country)
                            ? this.state.job.dropoff_address.country
                            : ''
                          }
                          id="dropoff_address_country"
                          required
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_postcode">
                          Postcode:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_postcode"
                          id="dropoff_address_postcode"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.postcode)
                            ? this.state.job.dropoff_address.postcode
                            : ''
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_opening_times">
                          Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_opening_times"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.opening_times)
                            ? this.state.job.dropoff_address.opening_times
                            : ''
                          }
                          id="dropoff_address_opening_times"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_compound_opening_times">
                          Compound Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_compound_opening_times"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.compound_opening_times)
                            ? this.state.job.dropoff_address.compound_opening_times
                            : ''
                          }
                          id="dropoff_address_compound_opening_times"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_contact_name">
                          Contact Name:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_contact_name"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.contact_name)
                            ? this.state.job.dropoff_address.contact_name
                            : ''
                          }
                          id="dropoff_address_contact_name"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_contact_telephone_number">
                          Contact Telephone Number:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_contact_telephone_number"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.contact_telephone_number)
                            ? this.state.job.dropoff_address.contact_telephone_number
                            : ''
                          }
                          id="dropoff_address_contact_telephone_number"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  <p>
                    <label htmlFor="recalculate_latt_and_long">
                      <input
                        type="checkbox"
                        name="recalculate_latt_and_long"
                        id="recalculate_latt_and_long"
                        defaultChecked={false}
                      /> recalculate latt and long
                    </label>
                  </p>
                  <p>
                    <label htmlFor="recalculate_distance">
                    <input
                      type="checkbox"
                      name="recalculate_distance"
                      id="recalculate_distance"
                      defaultChecked={false}
                    /> recalculate distance
                    </label>
                  </p>
                  <p>
                    <label htmlFor="recalculate_duration">
                    <input
                      type="checkbox"
                      name="recalculate_duration"
                      id="recalculate_duration"
                      defaultChecked={false}
                    /> recalculate duration
                    </label>
                  </p>
                  <p>
                    <label htmlFor="recalculate_job_price">
                      <input
                      type="checkbox"
                      name="recalculate_job_price"
                      id="recalculate_job_price"
                      defaultChecked={false}
                      /> recalculate job price
                    </label>
                  </p>
                  <p>
                    <label htmlFor="recalculate_driver_price">
                    <input
                      type="checkbox"
                      name="recalculate_driver_price"
                      id="recalculate_driver_price"
                      defaultChecked={false}
                    /> recalculate driver price
                    </label>
                  </p>
                </div>
              </div>
              <div className="scheduler-submit-buttons-container">
                <button
                  className="btn btn-lg btn-primary"
                  onClick={() =>
                    this.handleJobUpdate(true, false)
                  }
                  type="button">
                  <i className="fa fa-save">
                  </i>&nbsp;
                  Save Job
                </button>
                &nbsp;&nbsp;&nbsp;
                <button
                  className="btn btn-lg btn-success"
                  onClick={() =>
                    this.handleJobUpdate(true, true)
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Save and Send Job to Driver
                </button>
              </div>
              <br/><br/><br/>
            </fieldset>
          </form>
        </div>
      </div> : null)}
    </div>
    );
  }
}
